import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Check item availability at a specific branch for delivery
 * @param {Object} data - Contains restaurant_id, branch_id and item_ids
 * @returns {Promise<Object>} - Response data from the API
 */
export const checkItemAvailability = async (data) => {
  try {
    const response = await apiClient.post(
      API_ENDPOINTS.CHECK_ITEM_AVAILABILITY, 
      data
    );
    return response.data.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
}; 